import React, { useState, useEffect, useRef } from 'react';
import { Factory, Building, Target, Truck, Award,  Beaker } from 'lucide-react';

const CompanyFoundationTimeline = () => {
  const [visibleItems, setVisibleItems] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [itemsPerView, setItemsPerView] = useState(3);
  const timelineRef = useRef(null);

  const timelineData = [
    {
      id: 100,
      date: "1976-01-01",
      title: "Inicio de operaciones con productos de origen nacional.",
      description: "Inicio de operaciones con productos de origen nacional.",
      location: "México",
      icon: Factory,
      color: "from-lime-400 to-green-500"
    },
    {
      id: 101,
      date: "1983-01-01",
      title: "Complemento con productos importados",
      description: "La oferta de productos se complementa con productos importados.",
      location: "México",
      icon: Truck,
      color: "from-amber-400 to-orange-500"
    },
    {
      id: 1,
      date: "1999-01-01",
      title: "Inicio de Operaciones en Almacenes Vaca",
      description: "Comienzo de actividades en Vaca con envasado base. Participación en ventas centrales de abastos, estableciendo los primeros pasos en la industria alimentaria.",
      location: "Irapuato, Guanajuato, México",
      icon: Factory,
      color: "from-lime-400 to-green-500"
    },
    {
      id: 102,
      date: "2002-01-01",
      title: "Inauguración de la Planta Ciudad Industrial",
      description: "Inauguración de la Planta Ciudad Industrial.",
      location: "México",
      icon: Building,
      color: "from-blue-400 to-blue-600"
    },
    {
      id: 103,
      date: "2004-01-01",
      title: "Inauguración de la Planta de Avena",
      description: "Inauguración de la Planta de Avena.",
      location: "México",
      icon: Factory,
      color: "from-yellow-400 to-yellow-600"
    },
    {
      id: 104,
      date: "2006-01-01",
      title: "Apertura de Centros de Distribución Guadalajara",
      description: "Apertura de Centros de Distribución Guadalajara.",
      location: "Guadalajara, México",
      icon: Truck,
      color: "from-purple-400 to-purple-600"
    },
    {
      id: 2,
      date: "2009-01-01",
      title: "Consolidación en Ventas Centrales",
      description: "Fortalecimiento de la presencia en ventas centrales de abastos. Vaca ya contaba con más de 10 años de experiencia en el mercado.",
      location: "Irapuato, Guanajuato, México",
      icon: Truck,
      color: "from-amber-400 to-orange-500"
    },
    {
      id: 3,
      date: "2010-01-01",
      title: "Arranque de Maquilas y Proceso de Empacado",
      description: "Inicio del proceso de empacado y arranque de maquilas de marcas propias para diferentes clientes. Diversificación del modelo de negocio.",
      location: "Irapuato, Guanajuato, México",
      icon: Award,
      color: "from-pink-400 to-pink-600"
    },
    {
      id: 4,
      date: "2012-01-01",
      title: "Construcción de Nueva Planta",
      description: "Arranque y construcción de nueva planta industrial. Inversión significativa en infraestructura que se extenderá hasta 2018.",
      location: "México",
      icon: Building,
      color: "from-blue-400 to-blue-600"
    },
    {
      id: 105,
      date: "2012-01-01",
      title: "Apertura de la Planta Campo Fresco",
      description: "Apertura de la Planta Campo Fresco.",
      location: "México",
      icon: Building,
      color: "from-green-400 to-green-600"
    },
    {
      id: 106,
      date: "2014-01-01",
      title: "Apertura de la Planta Zacatecas (RG)",
      description: "Apertura de la Planta Zacatecas (RG).",
      location: "Zacatecas, México",
      icon: Building,
      color: "from-pink-400 to-pink-600"
    },
    {
      id: 5,
      date: "2015-01-01",
      title: "Lanzamiento de Productos de Jamaica",
      description: "Introducción de productos de Jamaica al portafolio. Arranque de un nuevo producto que amplía la variedad de ofertas.",
      location: "Calera, Guanjuato, México",
      icon: Target,
      color: "from-fuchsia-400 to-rose-500"
    },
    {
      id: 6,
      date: "2018-01-01",
      title: "Finalización de Construcción de Planta",
      description: "Culmina el período de construcción iniciado en 2012. Planta completamente operativa con capacidad expandida.",
      location: "Calera, Guanjuato, México",
      icon: Building,
      color: "from-blue-500 to-blue-700"
    },
    {
      id: 7,
      date: "2021-01-01",
      title: "Arranque de Planta de Procesados",
      description: "Puesta en marcha de la planta de procesados - el producto que catapultó a la empresa. Apertura a un mercado totalmente diferente de productos procesados.",
      location: "Calera, Guanjuato, México",
      icon: Factory,
      color: "from-emerald-400 to-green-700",
      highlight: true
    },
    {
      id: 8,
      date: "2023-01-01",
      title: "Fundación del Laboratorio de Desarrollo",
      description: "Creación del laboratorio especializado en desarrollo de productos con tecnología avanzada: autoclave, refractómetros, básculas analíticas, termobalanzas, equipos de pH y titulación.",
      location: "Calera, Guanjuato, México",
      icon: Beaker,
      color: "from-purple-400 to-violet-600",
      highlight: true
    },
    {
      id: 9,
      date: "2025-01-01",
      title: "Automatización con Robotica",
      description: "Próxima inauguración de cadena de ensamble con robot automatizado. Modernización tecnológica hacia la Industria 4.0.",
      location: "Calera, Guanjuato, México",
      icon: Target,
      color: "from-cyan-400 to-blue-500",
      future: true
    }
  ];

  // Detectar el tamaño de pantalla
  useEffect(() => {
    const checkScreenSize = () => {
      const mobile = window.innerWidth < 768;
      const tablet = window.innerWidth >= 768 && window.innerWidth < 1024;
      
      setIsMobile(mobile);
      
      if (mobile) {
        setItemsPerView(1);
      } else if (tablet) {
        setItemsPerView(2);
      } else {
        setItemsPerView(3);
      }
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // Intersection Observer
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.2) {
            setIsVisible(true);
          }
        });
      },
      {
        threshold: [0.1, 0.2, 0.3],
        rootMargin: '-20px 0px'
      }
    );

    const refCurrent = timelineRef.current;
    if (refCurrent) {
      observer.observe(refCurrent);
    }

    return () => {
      if (refCurrent) {
        observer.unobserve(refCurrent);
      }
    };
  }, []);

  // Animación progresiva
  useEffect(() => {
    let timer;
    
    if (isVisible && visibleItems < timelineData.length) {
      timer = setTimeout(() => {
        setVisibleItems(prev => prev + 1);
      }, isMobile ? 3000 : 2000);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [isVisible, visibleItems, timelineData.length, isMobile]);

  // Auto-scroll cuando aparecen más elementos que los visibles
  useEffect(() => {
    if (visibleItems > itemsPerView && isPlaying) {
      const maxIndex = Math.max(0, timelineData.length - itemsPerView);
      const targetIndex = Math.min(visibleItems - itemsPerView, maxIndex);
      setCurrentIndex(targetIndex);
    }
  }, [visibleItems, isPlaying, itemsPerView, timelineData.length]);

  // Auto-scroll continuo después de mostrar todos los elementos
  useEffect(() => {
    let timer;
    
    if (isPlaying && visibleItems === timelineData.length) {
      const maxIndex = Math.max(0, timelineData.length - itemsPerView);
      
      timer = setInterval(() => {
        setCurrentIndex(prev => {
          return (prev + 1) % (maxIndex + 1);
        });
      }, isMobile ? 5000 : 3000);
    }

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [isPlaying, visibleItems, timelineData.length, itemsPerView, isMobile]);

  const resetAnimation = () => {
    setVisibleItems(0);
    setIsVisible(false);
    setCurrentIndex(0);
    setIsPlaying(true);
    
    setTimeout(() => {
      setIsVisible(true);
    }, 300);
  };

  const togglePlayPause = () => {
    setIsPlaying(!isPlaying);
  };

  const goToSlide = (index) => {
    const maxIndex = Math.max(0, timelineData.length - itemsPerView);
    setCurrentIndex(Math.min(index, maxIndex));
    setIsPlaying(false);
  };

  // Calcular el desplazamiento basado en items por vista
  const translateX = -(currentIndex * (100 / itemsPerView));
  const maxSlides = Math.max(0, timelineData.length - itemsPerView + 1);

  return (
    <div className="min-h-screen bg-green-50 p-4 sm:p-6 lg:p-8">
      <div ref={timelineRef} className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12 lg:mb-16">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 lg:mb-6 bg-gradient-to-r from-green-600 to-emerald-600 bg-clip-text text-transparent">
            Historia de Campo Fresco
          </h1>
          <p className="text-gray-700 text-base sm:text-lg lg:text-xl mb-6 lg:mb-8 max-w-3xl mx-auto leading-relaxed px-4">
            Más de 40 años de trayectoria en la producción y procesamiento de granos de alta calidad
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-4">
            <button
              onClick={resetAnimation}
              className="px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white rounded-xl font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-green-500/25"
            >
              ▶ Reproducir Historia
            </button>
            
            {visibleItems >= itemsPerView && (
              <button
                onClick={togglePlayPause}
                className="px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-gray-600 to-gray-700 hover:from-gray-700 hover:to-gray-800 text-white rounded-xl font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg"
              >
                {isPlaying ? '⏸ Pausar' : '▶ Continuar'}
              </button>
            )}
          </div>
        </div>

        {/* Timeline Container */}
        <div className="relative mb-12 lg:mb-16">
          <div className="overflow-hidden">
            <div 
              className="flex transition-transform duration-1000 ease-in-out"
              style={{ transform: `translateX(${translateX}%)` }}
            >
              {timelineData.map((item, index) => {
                const IconComponent = item.icon;
                const isItemVisible = index < visibleItems;
                
                return (
                  <div
                    key={item.id}
                    className={`${
                      itemsPerView === 1 ? 'w-full' : 
                      itemsPerView === 2 ? 'w-1/2' : 'w-1/3'
                    } flex-shrink-0 px-2 sm:px-4 transition-all duration-1000 ${
                      isItemVisible 
                        ? 'opacity-100 transform translate-y-0' 
                        : 'opacity-0 transform translate-y-8'
                    }`}
                    style={{ transitionDelay: `${index * 200}ms` }}
                  >
                    <div className={`bg-white border-2 rounded-2xl p-4 sm:p-6 lg:p-8 h-full transition-all duration-300 shadow-md relative overflow-hidden ${
                      item.highlight 
                        ? 'border-yellow-400 hover:border-yellow-500 hover:shadow-yellow-200/50' 
                        : item.future 
                        ? 'border-cyan-300 hover:border-cyan-400 hover:shadow-cyan-200/50' 
                        : 'border-green-200 hover:border-green-400'
                    } hover:shadow-xl`}>
                      
                      {/* Badge especial para hitos importantes */}
                      {item.highlight && (
                        <div className="absolute top-4 right-4 bg-gradient-to-r from-yellow-400 to-orange-500 text-black text-xs font-bold px-3 py-1 rounded-full">
                          HITO CLAVE
                        </div>
                      )}
                      
                      {item.future && (
                        <div className="absolute top-4 right-4 bg-gradient-to-r from-cyan-400 to-blue-500 text-black text-xs font-bold px-3 py-1 rounded-full">
                          PRÓXIMAMENTE
                        </div>
                      )}

                      <div className="flex items-center justify-between mb-4 lg:mb-6">
                        <div className={`p-3 lg:p-4 rounded-xl bg-gradient-to-r ${item.color} shadow-lg`}>
                          <IconComponent className="w-6 h-6 lg:w-8 lg:h-8 text-white" />
                        </div>
                        <div className="text-right">
                          <div className="text-gray-700 text-xs sm:text-sm font-medium mb-1">
                            {item.future ? 'Próximamente' : new Date(item.date).getFullYear()}
                          </div>
                          <div className="text-gray-600 text-xs">
                            📍 {item.location}
                          </div>
                        </div>
                      </div>
                      
                      <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-900 mb-3 lg:mb-4 leading-tight">
                        {item.title}
                      </h3>
                      
                      <p className="text-gray-700 leading-relaxed text-sm sm:text-base">
                        {item.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Indicadores de navegación */}
        {visibleItems >= itemsPerView && maxSlides > 1 && (
          <div className="flex justify-center gap-2 sm:gap-3 mb-8 lg:mb-12 flex-wrap">
            {Array.from({ length: maxSlides }, (_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-3 h-3 sm:w-4 sm:h-4 rounded-full transition-all duration-300 ${
                  currentIndex === index
                    ? 'bg-gradient-to-r from-green-500 to-emerald-600 shadow-lg scale-125'
                    : 'bg-gray-400 hover:bg-gray-500'
                }`}
              />
            ))}
          </div>
        )}

        {/* Barra de progreso */}
        <div className="mt-8 lg:mt-12 mb-8 lg:mb-12">
          <div className="bg-green-200 rounded-full h-2 sm:h-3 mb-4 lg:mb-6 overflow-hidden shadow-inner">
            <div 
              className="bg-gradient-to-r from-green-600 via-emerald-600 to-green-700 h-full rounded-full transition-all duration-1000 ease-out relative shadow-sm"
              style={{ width: `${(visibleItems / timelineData.length) * 100}%` }}
            >
              <div className="absolute inset-0 bg-white/20 animate-pulse rounded-full"></div>
            </div>
          </div>
          <div className="text-center">
            <p className="text-gray-800 text-base sm:text-lg font-medium">
              Hitos Revelados: <span className="text-green-800 font-bold">{visibleItems}</span> de <span className="text-green-800 font-bold">{timelineData.length}</span>
            </p>
            <p className="text-gray-700 mt-2 text-sm sm:text-base">
              {Math.round((visibleItems / timelineData.length) * 100)}% de la historia completada
            </p>
          </div>
        </div>
      </div>

      {/* Sección de productos y capacidades actuales */}
      <div className="max-w-6xl mx-auto mt-16 lg:mt-24">
        <div className="text-center mb-8 lg:mb-12">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">Nuestras Capacidades Actuales</h2>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8 mb-12">
          {/* Productos */}
          <div className="p-6 sm:p-8 bg-white rounded-2xl border-2 border-green-200 shadow-md hover:shadow-lg transition-all duration-300">
            <h3 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-4 flex items-center gap-3">
              <Factory className="w-5 h-5 sm:w-6 sm:h-6 text-green-600" />
              Productos Principales
            </h3>
            <div className="space-y-3">
              <div className="p-3 bg-green-50 rounded-lg">
                <p className="font-semibold text-green-900">Frijoles Refritos:</p>
                <p className="text-sm text-green-800">Bayo, Negro y rojo</p>
              </div>
              {/* <div className="p-3 bg-blue-50 rounded-lg">
                <p className="font-semibold text-blue-900">Marcas que Maquilamos:</p>
                <p className="text-sm text-blue-800">Great Value (Walmart), Campo Santo (3B), Buena Mark (Bara), Selecto Brand (Chedraui), Ballet Foods (Soriana)</p>
              </div> */}
              <div className="p-3 bg-purple-50 rounded-lg">
                <p className="font-semibold text-purple-900">Exportación:</p>
                <p className="text-sm text-purple-800">Marca Pueblo Rico - Frijol negro, rojo y bayo (8, 10, 14, 28 oz)</p>
              </div>
            </div>
          </div>
          
          {/* Laboratorio */}
          <div className="p-6 sm:p-8 bg-white rounded-2xl border-2 border-purple-200 shadow-md hover:shadow-lg transition-all duration-300">
            <h3 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-4 flex items-center gap-3">
              <Beaker className="w-5 h-5 sm:w-6 sm:h-6 text-purple-600" />
              Laboratorio de Desarrollo
            </h3>
            <div className="space-y-3">
              <div className="p-3 bg-purple-50 rounded-lg">
                <p className="font-semibold text-purple-900">Equipamiento:</p>
                <p className="text-sm text-purple-800">Autoclave, Refractómetros, Básculas analíticas, Termobalanzas, Equipos de pH y titulación</p>
              </div>
              <div className="p-3 bg-yellow-50 rounded-lg">
                <p className="font-semibold text-yellow-900">Capacidades:</p>
                <p className="text-sm text-yellow-800">Desarrollo de granos, cápsulas, mayonesas, aderezos, mostazas</p>
              </div>
              <div className="p-3 bg-red-50 rounded-lg">
                <p className="font-semibold text-red-900 flex items-center gap-2">
                  <span className="font-bold text-red-600">INOCUIDAD</span>
                </p>
                <p className="text-sm text-red-800">Productos seguros que no causen daños al consumidor</p>
              </div>
            </div>
          </div>
        </div>

        {/* Futuro */}
        <div className="p-6 sm:p-8 bg-gradient-to-r from-cyan-50 to-blue-50 rounded-2xl border-2 border-cyan-200 shadow-md">
          <h3 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-4 flex items-center gap-3">
            <Target className="w-5 h-5 sm:w-6 sm:h-6 text-cyan-600" />
            Próximos Desarrollos
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="p-4 bg-white rounded-xl border border-cyan-200">
              <p className="font-semibold text-cyan-900">Automatización</p>
              <p className="text-sm text-cyan-800">Cadena de ensamble con robot automatizado</p>
            </div>
            <div className="p-4 bg-white rounded-xl border border-cyan-200">
              <p className="font-semibold text-cyan-900">Nuevos Productos</p>
              <p className="text-sm text-cyan-800">Lanzamiento de frijol entero para mercado nacional</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyFoundationTimeline;